"use client"

import { useTranslations } from "next-intl"
import type { RecipeCogsStatus } from "@/lib/shopify/bundles/types"

/** Why a bundle's recipe COGS is incomplete; null when every component is priced. */
export function useRecipeCogsWarning(): (status: RecipeCogsStatus) => string | null {
  const tUi = useTranslations("Shopify.ShopifyEconomicsRecipeCogsWarning")
  return (status) => {
    switch (status) {
      case "ok":
        return null
      case "missing_sku_costs":
        return tUi("missingSkuCosts")
      case "has_family_components":
        return tUi("hasFamilyComponents")
    }
  }
}
